import {
  Component,
  Input,
  inject,
  input,
  output,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from '@openng/optimus-ui/button';
import { DialogModule } from '@openng/optimus-ui/dialog';
import { PickListModule } from '@openng/optimus-ui/picklist';
import { take } from 'rxjs/operators';
import { ContactList } from 'src/app/model/contacts/contact-list';
import { MemberCode } from 'src/app/model/contacts/member-code';
import { ProgressSpinnerComponent } from '../../../core/components/progress-spinner.component';
import { ContactListApiService } from 'src/app/services/api/contact-list-api.service';

@Component({
  selector: 'app-member-codes-form',
  imports: [
    DialogModule,
    ReactiveFormsModule,
    PickListModule,
    TranslateModule,
    ButtonModule,
    ProgressSpinnerComponent,
  ],
  templateUrl: './member-codes-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './member-codes-form.component.scss',
})
export class MemberCodesFormComponent implements OnInit {
  private _contactListApi = inject(ContactListApiService);

  @Input() isVisible: boolean = false;
  readonly contactList = input<ContactList>();
  readonly formTitle = input<string>('');

  readonly memberCodesHidden = output();
  readonly memberCodesUpdated = output<MemberCode[]>();

  loading: boolean = false;
  saving: boolean = false;
  availableMemberCodes: MemberCode[] = [];
  memberCodes: MemberCode[] = [];
  sourcePicklist: MemberCode[] = [];
  targetPicklist: MemberCode[] = [];

  manageMemberCodesForm = new UntypedFormGroup({
    memberCode: new UntypedFormControl(null),
  });

  ngOnInit(): void {
    this.loadMemberCodes();
  }

  loadMemberCodes() {
    this.loading = true;
    this._contactListApi
      .getMemberCodes()
      .pipe(take(1))
      .subscribe({
        next: (codes) => {
          this.availableMemberCodes = codes;
          if (!this.contactList()) {
            this.sourcePicklist = [...this.availableMemberCodes];
            this.loading = false;
            return;
          }

          this.availableMemberCodes.forEach((c) => {
            if (
              this.contactList()
                ?.memberCodes?.map((mc: MemberCode) => mc.id)
                .includes(c.id)
            ) {
              this.targetPicklist.push(c);
            } else {
              this.sourcePicklist.push(c);
            }
          });
          this.loading = false;
        },
        error: (error) => {
          console.error(error);
          this.loading = false;
        },
      });
  }

  updateContactListMemberCodes() {
    this.memberCodesUpdated.emit([...this.targetPicklist]);
  }

  onDialogHide() {
    this.memberCodesHidden.emit();
  }
}
